import { observer } from 'mobx-react';
import { FC } from 'react';
import CrossSellingProduct from '../../components/CrossSellingProduct/CrossSellingProduct';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import { emptyArray } from 'src/utils/helpers';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import './style.scss';

const CrossSellingProducts: FC = observer((): JSX.Element | null => {
  if (!orderProductModalStore.crossSellingProducts.length && !orderProductModalStore.crossSellingLoading) return null;

  return (
    <ScrollableBlock showScrollbar scrollbarSize="small" direction="horizontal" className="product-cross-selling__products" scrollClassName="gap-20">
      {orderProductModalStore.crossSellingLoading
        ? emptyArray(2).map((product, index) => <CrossSellingProduct key={`skeleton-${index}`} product={product} />)
        : orderProductModalStore.crossSellingProducts.map((product) => <CrossSellingProduct key={`product-${product?.id}`} product={product} />)}
    </ScrollableBlock>
  );
});

export default CrossSellingProducts;
